module.exports = __webpack_public_path__ + "static/media/selling.37df7ea5.png";